import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseEntityService } from "./rest-common.service";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class SystemService extends BaseEntityService {
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  getOSFamilys(args: String = "", fields: String = "") {
    return this.get(
      `${this.BASE_API_URL}/operating-system-family/?${fields}${args}`
    );
  }

  getOSVersions(args: String = "", fields: String = "") {
    return this.get(
      `${this.BASE_API_URL}/operating-system-extended/?${fields}${args}`
    );
  }

  getBrowsers(args: String = "", fields: String = "") {
    return this.get(`${this.BASE_API_URL}/browser/?${fields}${args}`);
  }

  getBrowserlanguages(args: String = "", fields: String = "") {
    return this.get(`${this.BASE_API_URL}/language/?${fields}${args}`);
  }

  getDeviceModels(args: String = "", fields: String = "") {
    return this.get(`${this.BASE_API_URL}/device-model/?${fields}${args}`);
  }

  getCarrers(args: String = "", fields: String = "") {
    return this.get(`${this.BASE_API_URL}/carrier/?${fields}${args}`);
  }

  getSystemGlobalSearchResult(search) {
    let params = {
      // 'search_fields': search_field,
      search_term: search,
      // 'fields': 'id,name'
    };
    return this.get(this.buildUrl(`${this.BASE_API_URL}/systems/`, "", params));
  }

  getInstanceDetails() {
    return this.get(`${this.BASE_API_URL}/sys-info`);
  }

  getAdspCurrency(params = {}){
    let url = this.buildUrl(`${this.BASE_API_URL}/sys-info/adsp-settings/`, '', params)
    return this.get(url);
  }

  // getSystemSearchResult(
  //   fields: String = "",
  //   searchFields = "name",
  //   query = ""
  // ) {
  //   return this.get(
  //     `${this.BASE_API_URL}/systems/?${fields}search_field=${searchFields}&search=${query}`
  //   );
  // }
}

@Injectable({
  providedIn: "root",
})
export class PLReportService extends BaseEntityService {
  public resource_url = `${this.BASE_API_URL}/sys-reports/`;

  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  checkUserPlReportAccess(params = {}) {
    let url = this.buildUrl(`${this.resource_url}p-and-l-user/`, "", params);
    return this.get(url)
  }

  getReportingOptions(params = {}) {
    let url = this.buildUrl(`${this.resource_url}p-and-l-report-meta/`, "", params);
    return this.get(url)
  }


  generate(data = {}, params = {}) {
    let url = this.buildUrl(`${this.resource_url}p-and-l-report/`, "", params)
    return this.post(url, data)
  }

  view(params = {}) {
    let url = this.buildUrl(`${this.resource_url}get-p-and-l-report/`, "", params)
    return this.get(url)
  }

}
